export enum BorrowRepayStrategy {
  TOTAL = "total",
  PARTIAL = "partial",
}

export enum BorrowPartialRepayStrategy {
  INCREASE_RATIO = "increase-ratio",
  WITHDRAW_COLLATERAL = "witdraw-collateral",
}

export enum BorrowMoreStrategy {
  INCREASE_COLLATERAL = "increase-collateral",
  DECREASE_RATIO = "decrease-ratio",
}

export enum BorrowCollateralManagementStrategy {
  DEPOSIT_COLLATERAL = "deposit-collateral",
  WITHDRAW_COLLATERAL = "withdraw-collateral",
}

export enum BorrowCollateralManagementActionUnit {
  AMOUNT = "collateral-amount",
  RATIO = "collateral-ratio",
}
